<div *ngFor="let list of dataSource">
	<div class="{{ list[0].rowClass }}" fxLayout="row" fxLayoutGap="2rem">
		<div *ngFor="let row of list" style="width: 100%">
			<div *ngIf="row.valueType === 'copy'" class="{{ row.labelTextClass }}" fxFlex="50">
				<span>{{ row.labelText }}</span>
				<i
					(click)="utilService.copyToClipboard(row.labelText, 'Copied')"
					*ngIf="row.icon.length > 0"
					class="material-icons {{ row.iconClass }} m-l-1 cursor-pointer fn-size-15"
				>
					{{ row.icon }}
				</i>
			</div>

			<div *ngIf="row.valueType !== 'copy'" class="{{ row.labelTextClass }}" fxFlex="50">
				<i
					*ngIf="row.icon.length > 0"
					class="material-icons {{ row.iconClass }}"
					style="margin-right: 1rem"
					>{{ row.icon }}</i
				>
				<span *ngIf="row.icon.length == 0">{{ row.labelText }}</span>
				<b *ngIf="row.icon.length > 0" class="font-weight-700">{{ row.labelText }}</b>
			</div>

			<div
				[ngSwitch]="row.valueType"
				class="{{ row.labelValueClass }}"
				fxFlex="50"
				fxLayoutAlign="{{ row.labelValueFlexLayout }}"
			>
				<div *ngSwitchCase="'string'">
					{{ (row.labelValue || '') + (row.valueUnit || '') }}
				</div>
				<div
					*ngSwitchCase="'location'"
					[appTruncateTooltip]="(row.labelValue || '') + (row.valueUnit || '')"
					class="truncate_text"
				>
					{{ (row.labelValue || '') + (row.valueUnit || '') }}
				</div>
				<div *ngSwitchCase="'number'">
					{{ row.labelValue | number: '1.0-0' }}{{ row.valueUnit }}
				</div>
				<div *ngSwitchCase="'specialInstructions'" fxFlex="100">
					<app-special-instructions-dialog
						[layoutAlign]="'center center'"
						[specialInstructions]="row.labelValue"
					>
					</app-special-instructions-dialog>
				</div>
				<div *ngSwitchCase="'date'">
					{{ row.labelValue | date: 'MM/dd/yyyy' }}
					{{ row.valueUnit }}
				</div>
				<div *ngSwitchCase="'currency'">
					{{ row.labelValue / 100 | currency: 'USD' }}
				</div>
				<div *ngSwitchCase="'longString'" fxLayoutAlign="start start">
					<span id="long-string" style="float: left">{{ row.labelValue + row.valueUnit }}</span>
					<span style="float: right">
						<mat-icon
							(click)="
								utilService.copyToClipboard(row.labelValue, COPY_TO_CLIPBOARD_MSGS.API_TOKEN)
							"
							style="margin-right: 0.5rem; cursor: pointer"
						>
							file_copy
						</mat-icon>
					</span>
				</div>

				<div *ngSwitchCase="'updatePlan'" fxFlex="100">
					<app-edit-plan
						(updatedPlan)="updatedPlan.emit($event)"
						*ngIf="!utilService.isNullOrUndefined(accountDetails.subscriptionId)"
						[accountDetails]="accountDetails"
						fxFlex="100"
					></app-edit-plan>
					<span *ngIf="utilService.isNullOrUndefined(accountDetails.subscriptionId)"> -- </span>
				</div>

				<div *ngSwitchCase="'copy'">
					{{ row.labelValue || '' }}
					<i
						(click)="utilService.copyToClipboard(row.labelValue, 'Copied')"
						*ngIf="row.icon.length > 0"
						class="material-icons {{ row.iconClass }} m-l-1 cursor-pointer fn-size-15"
					>
						{{ row.icon }}
					</i>
				</div>
			</div>
		</div>
	</div>
</div>
